var render = function render(){var _vm=this,_c=_vm._self._c;return _c('loading',{class:_vm.hiddenProps ? _vm.hiddenProps : '',attrs:{"active":_vm.activeSyncProps,"is-full-page":_vm.isFullPageProps,"height":45,"width":45,"color":'var(--blue70)',"backgroundColor":'var(--overlays-dark)'},on:{"update:active":function($event){_vm.activeSyncProps=$event}}})
}
var staticRenderFns = []

export { render, staticRenderFns }